module.exports = __webpack_public_path__ + "static/media/white-clock.d17836b3.svg";